<h1>
  {{ settings.welcome }}
</h1>
<p>Please select one of the following options to begin your application:</p>
<app-login> </app-login>
